// API Configuration for different environments
const API_CONFIG = {
  // For production with custom domain - dynamically detect protocol
  BASE_URL: typeof window !== 'undefined' 
    ? `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`
    : 'https://thecontainer.in',
  
  // Alternative URLs for fallback:
  // BASE_URL: 'https://container-hotel-prod-env.ap-south-1.elasticbeanstalk.com',
  //BASE_URL: 'http://localhost:8080', // For local development
  
  // API endpoints
  ENDPOINTS: {    AUTH: {
      LOGIN: '/api/auth/login',
      ADMIN_LOGIN: '/api/auth/admin/login',
      REGISTER: '/api/auth/register',
      SEND_OTP: '/api/auth/send-otp',
      VERIFY_OTP: '/api/auth/verify-otp'
    },
    ROOMS: {
      ALL: '/api/rooms',
      AVAILABLE: '/api/rooms/available',
      SEARCH: '/api/rooms/search',
      AVAILABILITY: '/api/rooms/availability'
    },
    BOOKINGS: {
      BASE: '/api/bookings',
      CREATE: '/api/bookings',
      PAY_AT_HOTEL: '/api/bookings/pay-at-hotel'
    },
    PAYMENTS: {
      CREATE_ORDER: '/api/payments/create-order',
      VERIFY: '/api/payments/verify',
      FAILURE: '/api/payments/failure'
    },    ADMIN: {
      NOTIFICATIONS: '/api/admin/notifications',
      ROOMS: '/api/admin/rooms',
      ROOM_IMAGE_UPLOAD: '/api/admin/rooms/upload-image',
      USERS: '/api/admin/users',
      BOOKINGS: '/api/admin/bookings',
      CONSOLIDATED_BOOKINGS: '/api/admin/bookings/consolidated',
      CONFIRM_CONSOLIDATED: '/api/admin/bookings/consolidated/{groupKey}/confirm'
    },
    HEALTH: '/api/health'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // If endpoint is already a full URL, return as is
  if (typeof endpoint === 'string' && endpoint.startsWith('http')) {
    return endpoint;
  }
  
  // Ensure endpoint starts with /
  const cleanEndpoint = endpoint && endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${API_CONFIG.BASE_URL}${cleanEndpoint}`;
};

// Get specific endpoint URLs
export const getEndpointUrl = (category, endpoint) => {
  try {
    if (category && endpoint) {
      const path = API_CONFIG.ENDPOINTS[category]?.[endpoint];
      if (path) {
        return getApiUrl(path);
      }
    }
    
    // If single parameter passed, treat as direct endpoint
    if (category && !endpoint) {
      const path = API_CONFIG.ENDPOINTS[category];
      if (path) {
        return getApiUrl(path);
      }
    }
    
    console.error('Error getting endpoint URL - Category:', category, 'Endpoint:', endpoint);
    console.error('Available endpoints:', API_CONFIG.ENDPOINTS);
    return getApiUrl('/api/fallback');
  } catch (error) {
    console.error('Error getting endpoint URL:', error);
    console.error('Category:', category, 'Endpoint:', endpoint);
    return getApiUrl('/api/fallback');
  }
};

export default API_CONFIG;

